// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoadingIndicator_wrapper__1caUG"};